import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, TemplateRef } from '@angular/core';
import { SkeletonTemplateService } from '@skeleton-loader';

@Component({
  selector: 'lib-product-title',
  imports: [CommonModule],
  templateUrl: './product-title.component.html',
  styleUrl: './product-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTitleComponent {
  brand = input.required<string>();
  name = input.required<string | TemplateRef<unknown>>();
  loading = input.required<boolean>();

  skeletonService = inject(SkeletonTemplateService);

  vm = computed(() => ({
    brand: this.brand(),
    name: this.name() as string,
    nameTemplate: this.name() as TemplateRef<unknown>,
    isNameTemplate: this.name() instanceof TemplateRef,
    isLoading: this.loading(),
  }));
}
